import api from './baseApi';
import _ from 'lodash';
import store from '@/store';

let outstringFormat = (response, cb, errCb) => {
  let outString = _.get(response, 'data.Outstring');

  if (outString == '000000000' || outString == '100000000') {
    if (cb) {
      cb(_.get(response, 'data.Result'));
    }
  } else if (outString == '200000002') {
    store.commit('user/setUser', {});
    store.commit('user/setShowModal', true);
  } else if (outString == '900000012') {
    if (errCb) {
      let data = _.get(response, 'data');
      errCb(data);
    } else {
      let message = _.get(response, 'data.Message');
      alert(message);
    }
  } else if (outString == '901000201') {
    let message = '此門店不適用於紅利點數折抵';
    errCb(message);
  } else if (outString == '901000413') {
    let message = '未達最低消費金額，此券不適用';
    errCb(message);
  } else if (outString == '901000402' || outString == '901000401') {
    let message = '此門店不適用於此券折抵';
    errCb(message);
  } else {
    if (errCb) {
      errCb();
    } else {
      let message = _.get(response, 'data.Message');
      alert(message);
    }
  }
};

export default (method, url, cb, config = {}, errCb) => {
  api(method, url, cb, config, errCb, outstringFormat);
};
